// Copyright (c) 2020, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { Query, Mutation } from 'react-apollo'
import * as Sentry from '@sentry/browser'

import { Button } from '../'

import { QUERY_REQUESTTYPE } from '../../queries'
import { MUTATION_REQUESTRUN } from '../../mutations'


export class ButtonRequestRunInitiate extends Component {
  static propTypes = {
    requestTypeId: PropTypes.string.isRequired,
    identityId: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    onInitiateTriggered: PropTypes.func,
    onInitiateDone: PropTypes.func,
    buttonType: PropTypes.oneOf(["reset", "brand", "destructive", "inverse", "default"]),
    className: PropTypes.string
  }

  static defaultProps = {
    type: 'brand',
    className: ''
  }

  initiate = (requestType, requestrunMutate) => {
    const { identityId, onInitiateTriggered, onInitiateDone } = this.props

    if (onInitiateTriggered) {
      onInitiateTriggered()
    }

    const input = {
      requesttype: requestType.id,
      identity: identityId,
      version: requestType.version,
      origin: 'form'
    }

    return requestrunMutate({ variables: { input } })
      .then(({ data }) => onInitiateDone(data.requestrunMutate.requestrun.id))
      .catch(error => {
        Sentry.captureMessage(`Failed to initiate verification request - ${error}`)
        onInitiateDone()
      })
  }

  render() {
    const { requestTypeId, disabled, buttonType, children, className } = this.props

    return (
      <Query query={QUERY_REQUESTTYPE} variables={{ id: requestTypeId }}>
        {({ loading, error, data }) => {
          if (loading || error) {
            return null
          }

          if (!data.requesttype) {
            return null
          }

          const requestType = data.requesttype

          return (
            <Mutation mutation={MUTATION_REQUESTRUN}>
              {(requestrunMutate, { data }) => (
                <Button
                  type={buttonType}
                  onClick={() => this.initiate(requestType, requestrunMutate)}
                  disabled={disabled}
                  className={className}>
                  {children}
                </Button>
              )}
            </Mutation>
          )
        }}
      </Query>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/button-requestrun-initiate/index.js